module.exports = __webpack_public_path__ + "img/icon-lose.e28c3483.svg";